












import { Vue, Component, Watch } from "vue-property-decorator";
import { DetectState } from "@/pages/detect/_state";

@Component
export default class PanelDetectionWaiting extends Vue {
  get waitingDetection() {
    return DetectState.waitingDetection;
  }

  @Watch("$route") function() {
    DetectState.waitingDetection = null;
  }

  goBack() {
    this.$router.push("/detect");
  }

  beforeDestroy() {
    DetectState.waitingDetection = null;
  }
}
